import { toNullableText } from '@/utils/textValue';
import { normalizeStatusLabel, normalizeYesNoLabel, toBooleanFlag } from '@/utils/dataNormalization';
import { getOptionValue, toPositiveOptionId } from '@/utils/optionValues';
import { parsePresentationDate, formatDateForApi } from '@/utils/datePresentation';

export const createInitialCustomerForm = () => ({
  name: '',
  admissionDate: new Date(),
  website: '',
  status: 'Activo',
  comment: '',
  email: '',
  phone: '',
  additionalPhone: '',
  customerType: null,
  size: null,
  sector: null,
  source: null,
  area: null,
  useBillingAddress: 'No',
  address: '',
  country: null,
  state: null,
  city: '',
  zipCode: '',
  creditDays: '',
  accountingAccount: '',
});

export const buildCustomerFormFromEntity = (entity = {}) => {
  const initial = createInitialCustomerForm();
  const admissionDateRaw = entity?.since_date ?? entity?.admissionDate ?? null;
  const normalizedAdmissionDate = parsePresentationDate(admissionDateRaw);

  return {
    ...initial,
    name: toNullableText(entity?.name),
    admissionDate: normalizedAdmissionDate,
    website: toNullableText(entity?.website),
    status: normalizeStatusLabel(entity?.status ?? entity?.active),
    comment: toNullableText(entity?.description ?? entity?.comment),
    email: toNullableText(entity?.email),
    phone: toNullableText(entity?.phone),
    additionalPhone: toNullableText(entity?.additionalPhone ?? entity?.fax),
    customerType: getOptionValue(entity?.type ?? entity?.customerType),
    size: getOptionValue(entity?.size),
    sector: getOptionValue(entity?.sector),
    source: getOptionValue(entity?.source),
    area: getOptionValue(entity?.area_id ?? entity?.area),
    useBillingAddress: normalizeYesNoLabel(entity?.useBillingAddress ?? entity?.use_billing_address),
    address: toNullableText(entity?.address),
    country: getOptionValue(entity?.country_code ?? entity?.country),
    state: getOptionValue(entity?.state_code ?? entity?.state),
    city: toNullableText(entity?.city),
    zipCode: toNullableText(entity?.zipcode ?? entity?.zipCode),
    creditDays: entity?.credit_days ?? entity?.creditDays ?? '',
    accountingAccount: toNullableText(entity?.reference ?? entity?.accountingAccount),
  };
};

// Keep front form shape but normalize selector values for submit payload.
export const buildCustomerCreatePayload = (form) => {
  const type = getOptionValue(form?.customerType);
  const size = getOptionValue(form?.size);
  const sector = getOptionValue(form?.sector);
  const source = getOptionValue(form?.source);
  const country = getOptionValue(form?.country);
  const state = getOptionValue(form?.state);

  return {
    name: String(form?.name || '').trim(),
    since_date: formatDateForApi(form?.admissionDate, { emptyValue: null, allowString: true }),
    status: form?.status || 'Activo',
    use_billing_address: toBooleanFlag(form?.useBillingAddress) ? 1 : 0,
    address: form?.address || '',
    website: form?.website || '',
    description: form?.comment || '',
    email: form?.email || '',
    phone: form?.phone || '',
    additionalPhone: form?.additionalPhone || '',
    type: type || 'default',
    size: size || '',
    sector: sector || '',
    source: source || '',
    area_id: toPositiveOptionId(form?.area),
    country: country || '',
    state: state || '',
    city: form?.city || '',
    zipcode: form?.zipCode || '',
    credit_days: form?.creditDays || 0,
    reference: form?.accountingAccount || '',
  };
};
